module.exports = __webpack_public_path__ + "img/jielong_code.f506b3a5.jpg";